<template>
  <div
    class="the-settings-starts-price"
    v-loading="loading"
  >
    <h3>Налаштування вартості</h3>
    <p>Вкажіть вартість челеджу стартів у гривнях.</p>
    <div class="the-settings-starts-price__form">
      <el-input-number v-model="price" :min="0"></el-input-number>
    </div>
    <el-button round type="success" @click="handleSave">Зберети</el-button>
  </div>
</template>

<script>
/**
 * Component: the-settings-starts-price - Компонент настройки категорий стартов
 *
 * @version 1.0.0
 */

import { mapGetters, mapActions } from 'vuex';


export default {
  name: 'the-settings-starts-price',

  data() {
    return {
      price: 0,
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      startsPrice: 'settings/startsPrice',
    }),
  },


  async created() {
    await this.getAppSettings();
    this.price = this.startsPrice;
  },

  methods: {
    async handleSave() {
      await this.setStartsPrice(this.price);
    },

    ...mapActions({
      setStartsPrice: 'settings/setStartsPrice',
      getAppSettings: 'settings/getAppSettings',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-settings-starts-price {
  $this: &;

  &__form {
    margin-bottom: 20px;
  }
}
</style>
